import Vue from 'vue'
import Component from 'vue-class-component'
import { createNewObjectPartDialog } from './dialogs'

@Component
class NewObjectPartMixin extends Vue {
  async createNewObjectPart () {
    const part = await createNewObjectPartDialog(this, this.$restorationObject)
    if (part) {
      await this.oarepo$.collectionItemModule.reload()
      this.notify$('Part successfully created')
    }
  }
}

export { NewObjectPartMixin }
